import { Utils } from "@lightningjs/sdk";
import { Row } from "./Row";
import { gameLogo } from "./gameLogo";
const asset = (name) => Utils.asset(`images/psg/${name}`);
export class PSGRow extends Row {
    static _template() {
        const row = super._template();
        return {
            alpha: row.alpha,
            h: this.H,
            Content: {
                x: -115,
                w: 1920,
                h: this.H,
                renderToTexture: true,
                Background: {
                    w: 1920,
                    h: 593,
                    clipping: true,
                    Pattern: {
                        x: -69,
                        y: -260,
                        w: 2084,
                        h: 1172,
                        src: asset("pattern.png"),
                    },
                    Shade: {
                        x: -42.46,
                        y: -45,
                        w: 1818,
                        h: 654,
                        rect: true,
                        colorLeft: 0xff1c1c1c,
                        colorRight: 0x001c1c1c,
                    },
                    Blue: {
                        x: 824.7,
                        y: -62.23,
                        mount: 0.5,
                        w: 2168.449,
                        h: 1012.052,
                        rotation: (-8.94 * Math.PI) / 180,
                        rect: true,
                        colorTop: 0xff1549a7,
                        colorBottom: 0x001549a7,
                    },
                    Players: {
                        x: 1019,
                        y: -4,
                        w: 790,
                        h: 659,
                        src: asset("players.png"),
                    },
                    Fade: {
                        y: 187,
                        w: 1920,
                        h: 336.75,
                        rect: true,
                        colorTop: 0x00161616,
                        colorBottom: 0xff161616,
                    },
                    Base: { y: 523.75, w: 1920, h: 69.25, rect: true, color: 0xff161616 },
                },
                Logo: Object.assign({ x: 184, y: 136, w: 204, h: 204 }, gameLogo(Utils.asset("images/watch-details/psg.svg"), 204, 204)),
                Title: {
                    x: 404,
                    y: 180,
                    text: {
                        fontFace: "Insatiable Display",
                        fontStyle: "700",
                        fontSize: 59,
                        precision: 1,
                        h: 68,
                        lineHeight: 68,
                        offsetY: 56.1,
                        letterSpacing: -1.18,
                        textColor: 0xffffffff,
                    },
                },
                Subtitle: {
                    x: 404,
                    y: 258,
                    text: {
                        text: "Latest updates",
                        fontFace: "Roboto",
                        fontStyle: "500",
                        fontSize: 32,
                        precision: 1,
                        h: 38,
                        lineHeight: 38,
                        offsetY: 31,
                        textColor: 0xffffffff,
                    },
                },
                List: Object.assign(Object.assign({}, row.List), { x: 117, y: 424, w: 1803, h: 270 }),
            },
        };
    }
    set title(title) {
        super.title = title;
        this.tag("List").y = 424;
    }
    createCard(item) {
        return Object.assign(Object.assign({}, super.createCard(item)), { h: 270, Description: { y: 214 }, Metadata: {
                y: 189,
                text: {
                    text: item.category,
                    fontFace: "Roboto",
                    fontStyle: "400",
                    fontSize: 18,
                    precision: 1,
                    h: 19,
                    lineHeight: 19,
                    offsetY: 16,
                    textColor: 0xffffffff,
                },
            }, PosterContainer: {
                Duration: {
                    x: 299,
                    y: 131,
                    Background: { color: 0xff494947, alpha: 0.6 },
                    Label: {
                        text: {
                            fontFace: "Roboto",
                            fontSize: 18,
                            precision: 1,
                            h: 23,
                            lineHeight: 23,
                            offsetY: 18,
                        },
                    },
                },
            } });
    }
}
PSGRow.H = 694;
//# sourceMappingURL=PSGRow.js.map